import type { DatabaseRowShardReadiness } from './data-source-contracts.js';

/**
 * The row-window readiness gates the first render of a database body. After
 * that, a local write leaves manifest and row shard briefly apart; that
 * `loading` must not unmount the mounted view with its open editors.
 */
export function resolveDatabaseBodyReadiness(
  readiness: DatabaseRowShardReadiness,
  initialLoadCompleted: boolean
): DatabaseRowShardReadiness {
  return initialLoadCompleted && readiness.status === 'loading'
    ? { status: 'ready' }
    : readiness;
}
